var _defs, _path, _path2, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCierrepasoDiagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 594.4 598.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #a00707;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.3,244.6l-.4-229.7c9.6-4.5,15.4-2,23.1,4.4,31.2,26.1,59.3,63.2,90.2,90.4,4,3.2,4.5,17.5,1.8,20.1l-114.6,114.6h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.4,359.5c-2.4,26.6,6.5,219.6-.8,228.3-5.8,6.8-16.3,1.6-21.7-3-31.1-25.6-59.3-63.6-90.2-90.6-4-3-4.5-17.4-1.9-20l114.6-114.6h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "328.8 154.1 331.3 161.7 331.2 382.5 270.2 443.5 269.4 213.5 328.8 154.1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "228.4 254.5 230.9 262 230.8 482.9 171.4 542.3 169 534.7 169 313.9 228.4 254.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "429.1 53.8 429.9 283.8 370.6 343.1 369.7 113.2 429.1 53.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCierrepasoDiagonal);
export default __webpack_public_path__ + "static/media/CIERRE PASO-DIAGONAL.1d8bf3a660f2e8a723fb09f3b54a7278.svg";
export { ForwardRef as ReactComponent };